import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { PublicBoardCustomFieldDateInput } from "~/components/PublicBoard/PublicBoardCustomFieldDateInput";
import { usePublicPermissions } from "~/components/PublicPermissionsProvider";
import { useURLBoardIdSelector } from "~/hooks/useURLBoardIdSelector";
import { canChangeBoardCustomFields } from "~/utils/permissions/boardPermissions";
import { PublicBoardPanelCustomFieldContainer } from "./PublicBoardPanelCustomFieldContainer";
export const PublicBoardPanelCustomFieldDateInput = /*#__PURE__*/ memo((param)=>{
    let { field } = param;
    const boardId = useURLBoardIdSelector();
    const { permissions } = usePublicPermissions();
    const canEditCustomFields = canChangeBoardCustomFields(permissions);
    if (!boardId) {
        return null;
    }
    return /*#__PURE__*/ _jsx(PublicBoardPanelCustomFieldContainer, {
        field: field,
        children: /*#__PURE__*/ _jsx(PublicBoardCustomFieldDateInput, {
            field: field,
            trackingLocation: "board-side-panel",
            canEditCustomFields: canEditCustomFields,
            boardId: boardId
        })
    });
});
PublicBoardPanelCustomFieldDateInput.displayName = "PublicBoardPanelCustomFieldDateInput";
